import { buildErrorMessageForName } from "@gettactic/helpers/src/hook-form/buildErrorMessageForName";
import React from "react";
import { Controller, FieldValues, Path, UseFormReturn } from "react-hook-form";
import { TagsInput } from "./TagsInput";
import { TagsInputProps } from "./TagsInput.types";

export interface HookFormTagsInputProps<T extends FieldValues>
  extends Omit<TagsInputProps, "selectedTags" | "onChangeValue" | "form"> {
  form: UseFormReturn<T>;
  name: Path<T>;
  isRequired?: boolean;
}

/**
 * `TagsInput` bound to a react-hook-form field holding the list of tag values.
 */
export const HookFormTagsInput = <T extends FieldValues>({
  form,
  name,
  isRequired,
  ...rest
}: HookFormTagsInputProps<T>): React.ReactElement => {
  return (
    <Controller
      control={form.control}
      name={name}
      rules={{
        required: isRequired
          ? { value: true, message: "This field is required" }
          : undefined
      }}
      render={({ field: { onChange, value } }) => (
        <TagsInput
          {...rest}
          selectedTags={value || []}
          onChangeValue={onChange}
          error={buildErrorMessageForName(form, name)}
        />
      )}
    />
  );
};
